import { MindmapPaletteKind } from "shared/src/types/mindmap-palette-kind";
import {
	MINDMAP_COLOR_BLACK_DIRTY,
	MINDMAP_COLOR_WHITE,
	MINDMAP_COLOR_WHITE_DIRTY,
	MINDMAP_THEME_PALETTE_COLORS_ARCADE,
	MINDMAP_THEME_PALETTE_COLORS_ARCTIC,
	MINDMAP_THEME_PALETTE_COLORS_ASPHALT,
	MINDMAP_THEME_PALETTE_COLORS_ATLAS,
	MINDMAP_THEME_PALETTE_COLORS_BEACON,
	MINDMAP_THEME_PALETTE_COLORS_BLOOM,
	MINDMAP_THEME_PALETTE_COLORS_DAYGLOW,
	MINDMAP_THEME_PALETTE_COLORS_BRIGHT,
	MINDMAP_THEME_PALETTE_COLORS_CAMPFIRE,
	MINDMAP_THEME_PALETTE_COLORS_CERAMIC,
	MINDMAP_THEME_PALETTE_COLORS_CHROME,
	MINDMAP_THEME_PALETTE_COLORS_COLORWHEEL,
	MINDMAP_THEME_PALETTE_COLORS_CONFETTI,
	MINDMAP_THEME_PALETTE_COLORS_CROWN,
	MINDMAP_THEME_PALETTE_COLORS_CYBER,
	MINDMAP_THEME_PALETTE_COLORS_DOCKSIDE,
	MINDMAP_THEME_PALETTE_COLORS_DUSK,
	MINDMAP_THEME_PALETTE_COLORS_ELECTRIC,
	MINDMAP_THEME_PALETTE_COLORS_EMBER,
	MINDMAP_THEME_PALETTE_COLORS_ENERGY,
	MINDMAP_THEME_PALETTE_COLORS_FIRE,
	MINDMAP_THEME_PALETTE_COLORS_FOREST,
	MINDMAP_THEME_PALETTE_COLORS_FRIENDS,
	MINDMAP_THEME_PALETTE_COLORS_GEMSTONE,
	MINDMAP_THEME_PALETTE_COLORS_GLACIER,
	MINDMAP_THEME_PALETTE_COLORS_GLOW,
	MINDMAP_THEME_PALETTE_COLORS_HARVEST,
	MINDMAP_THEME_PALETTE_COLORS_HEIRLOOM,
	MINDMAP_THEME_PALETTE_COLORS_MARSHMALLOW,
	MINDMAP_THEME_PALETTE_COLORS_MEADOW,
	MINDMAP_THEME_PALETTE_COLORS_MIDNIGHT,
	MINDMAP_THEME_PALETTE_COLORS_MINT,
	MINDMAP_THEME_PALETTE_COLORS_MIXTAPE,
	MINDMAP_THEME_PALETTE_COLORS_MURKY,
	MINDMAP_THEME_PALETTE_COLORS_NATURE,
	MINDMAP_THEME_PALETTE_COLORS_NEON,
	MINDMAP_THEME_PALETTE_COLORS_NOSTALGIA,
	MINDMAP_THEME_PALETTE_COLORS_OASIS,
	MINDMAP_THEME_PALETTE_COLORS_PAPRIKA,
	MINDMAP_THEME_PALETTE_COLORS_PARADE,
	MINDMAP_THEME_PALETTE_COLORS_PASTEL,
	MINDMAP_THEME_PALETTE_COLORS_PLAYFUL,
	MINDMAP_THEME_PALETTE_COLORS_ROSEWATER,
	MINDMAP_THEME_PALETTE_COLORS_RUST,
	MINDMAP_THEME_PALETTE_COLORS_SEASIDE,
	MINDMAP_THEME_PALETTE_COLORS_SPROUT,
	MINDMAP_THEME_PALETTE_COLORS_SUNDOWN,
	MINDMAP_THEME_PALETTE_COLORS_SUPERNOVA,
	MINDMAP_THEME_PALETTE_COLORS_SYNTHWAVE,
	MINDMAP_THEME_PALETTE_COLORS_TAILORED,
	MINDMAP_THEME_PALETTE_COLORS_TERRA,
	MINDMAP_THEME_PALETTE_COLORS_TIDES,
	MINDMAP_THEME_PALETTE_COLORS_TRON,
	MINDMAP_THEME_PALETTE_COLORS_TROPICAL,
	MINDMAP_THEME_PALETTE_COLORS_ULTRAVIOLET,
	MINDMAP_THEME_PALETTE_COLORS_VACATION,
	MINDMAP_THEME_PALETTE_COLORS_WAVELENGTH,
	MINDMAP_THEME_PALETTE_COLORS_WAVES,
	MindmapPalette,
	THEME_PALETTE_COLORS_CANDY
} from "mindmap";

export const MINDMAP_PALETTES: Record<MindmapPaletteKind, (isDark: boolean) => Partial<MindmapPalette>> = {
	energy: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ENERGY
	}),
	rust: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_RUST,
		backgroundColor: isDark ? "#0a0000" : "#f4f4f4",
		backgroundDotsColor: isDark ? null : "#e8e7e7"
	}),
	forest: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_FOREST,
		backgroundColor: isDark ? "#100b00" : "#fff5ea",
		backgroundDotsColor: null
	}),
	waves: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_WAVES,
		backgroundColor: isDark ? "#010f1c" : "#f2fbff",
		backgroundDotsColor: null
	}),
	nature: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_NATURE
	}),
	nostalgia: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_NOSTALGIA,
		backgroundColor: isDark ? "#150a00" : "#fff3f6",
		backgroundDotsColor: null
	}),
	ember: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_EMBER,
		backgroundColor: isDark ? "#140505" : "#fff4ec",
		backgroundDotsColor: null
	}),
	neon: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_NEON,
		backgroundColor: isDark ? "#070014" : "#fbf5ff",
		backgroundDotsColor: null
	}),
	arctic: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ARCTIC,
		backgroundColor: isDark ? "#020a14" : "#f1faff",
		backgroundDotsColor: null
	}),
	meadow: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MEADOW,
		backgroundColor: isDark ? "#04140a" : "#f6fff0"
	}),
	terra: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_TERRA,
		backgroundColor: isDark ? "#100a04" : "#fbf6ee"
	}),
	midnight: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MIDNIGHT,
		backgroundColor: isDark ? "#03051a" : "#f4f1ff",
		backgroundDotsColor: null
	}),
	dockside: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_DOCKSIDE,
		backgroundColor: isDark ? "#001a2d" : "#fff5ec",
		backgroundDotsColor: null
	}),
	beacon: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_BEACON,
		backgroundColor: isDark ? "#020c14" : "#f0f7ff",
		backgroundDotsColor: null
	}),
	atlas: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ATLAS,
		backgroundColor: isDark ? "#0a0b14" : "#f5f8fa",
		backgroundDotsColor: null
	}),
	cyber: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CYBER
	}),
	asphalt: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ASPHALT,
		backgroundColor: isDark ? "#0a0a0a" : "#f4f4f4",
		backgroundDotsColor: null
	}),
	parade: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_PARADE,
		backgroundColor: isDark ? "#000a14" : "#fff5ed",
		backgroundDotsColor: null
	}),
	rosewater: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ROSEWATER,
		backgroundColor: isDark ? "#140005" : "#fff0f4",
		backgroundDotsColor: null
	}),
	dayglow: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_DAYGLOW,
		backgroundColor: isDark ? "#0c0014" : "#fffaec",
		backgroundDotsColor: null
	}),
	campfire: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CAMPFIRE,
		backgroundColor: isDark ? "#040c10" : "#fff7ec",
		backgroundDotsColor: null
	}),
	arcade: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ARCADE
	}),
	harvest: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_HARVEST,
		backgroundColor: isDark ? "#0a0c05" : "#fbf9eb",
		backgroundDotsColor: null
	}),
	confetti: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CONFETTI,
		backgroundColor: isDark ? "#0a0010" : "#fff5ee",
		backgroundDotsColor: null
	}),
	tides: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_TIDES,
		backgroundColor: isDark ? "#020e10" : "#f0fbff",
		backgroundDotsColor: null
	}),
	bloom: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_BLOOM
	}),
	paprika: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_PAPRIKA,
		backgroundColor: isDark ? "#0a0200" : "#fff4e8",
		backgroundDotsColor: null
	}),
	gemstone: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_GEMSTONE
	}),
	crown: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CROWN,
		backgroundColor: isDark ? "#000514" : "#fffaea",
		backgroundDotsColor: null
	}),
	oasis: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_OASIS,
		backgroundColor: isDark ? "#000a10" : "#fff8ec",
		backgroundDotsColor: null
	}),
	sprout: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_SPROUT
	}),
	playful: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_PLAYFUL
	}),
	sundown: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_SUNDOWN,
		backgroundColor: isDark ? "#0a0014" : "#fff5ec",
		backgroundDotsColor: null
	}),
	seaside: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_SEASIDE,
		backgroundColor: isDark ? "#001014" : "#fffbe8",
		backgroundDotsColor: null
	}),
	heirloom: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_HEIRLOOM,
		backgroundColor: isDark ? "#0a0a14" : "#fbf8ec",
		backgroundDotsColor: null
	}),
	candy: (isDark) => ({
		colors: THEME_PALETTE_COLORS_CANDY
	}),
	pastel: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_PASTEL
	}),
	glow: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_GLOW,
		backgroundColor: isDark ? "#050113" : "#f9f4ff",
		backgroundDotsColor: null
	}),
	murky: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MURKY,
		backgroundColor: isDark ? "#000b00" : "#f7ffec",
		backgroundDotsColor: null
	}),
	fire: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_FIRE,
		backgroundColor: isDark ? "#0b0000" : "#ffecec",
		backgroundDotsColor: null
	}),
	vacation: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_VACATION
	}),
	bright: (isDark) =>
		isDark
			? {
					colors: [
						...MINDMAP_THEME_PALETTE_COLORS_BRIGHT,
						{ color: "#f9f9f9", contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "White" }
					],
					backgroundColor: "#090f1c",
					backgroundDotsColor: null
				}
			: {
					colors: [
						...MINDMAP_THEME_PALETTE_COLORS_BRIGHT,
						{ color: "#16233a", contrast: MINDMAP_COLOR_WHITE, name: "Black" }
					],
					backgroundColor: "#f9f9f9",
					backgroundDotsColor: null
				},
	mono: (isDark) => ({
		colors: isDark
			? [{ color: MINDMAP_COLOR_WHITE_DIRTY, contrast: MINDMAP_COLOR_BLACK_DIRTY, name: "White" }]
			: [{ color: MINDMAP_COLOR_BLACK_DIRTY, contrast: MINDMAP_COLOR_WHITE, name: "Black" }]
	}),
	electric: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ELECTRIC
	}),
	glacier: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_GLACIER
	}),
	marshmallow: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MARSHMALLOW
	}),
	chrome: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CHROME
	}),
	ceramic: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_CERAMIC
	}),
	wavelength: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_WAVELENGTH
	}),
	ultraviolet: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_ULTRAVIOLET
	}),
	mint: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MINT
	}),
	supernova: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_SUPERNOVA
	}),
	tailored: () => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_TAILORED
	}),
	colorwheel: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_COLORWHEEL,
		backgroundColor: isDark ? "#0e0a14" : "#fdf7ff",
		backgroundDotsColor: null
	}),
	mixtape: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_MIXTAPE,
		backgroundColor: isDark ? "#140a0a" : "#fff8f0",
		backgroundDotsColor: null
	}),
	tropical: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_TROPICAL,
		backgroundColor: isDark ? "#001a1f" : "#f0fdf9",
		backgroundDotsColor: null
	}),
	dusk: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_DUSK,
		backgroundColor: isDark ? "#1a0e1f" : "#fff5e8",
		backgroundDotsColor: null
	}),
	tron: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_TRON,
		backgroundColor: isDark ? "#000a14" : "#e8f8ff",
		backgroundDotsColor: null
	}),
	synthwave: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_SYNTHWAVE,
		backgroundColor: isDark ? "#0a0014" : "#fff0f8",
		backgroundDotsColor: null
	}),
	friends: (isDark) => ({
		colors: MINDMAP_THEME_PALETTE_COLORS_FRIENDS,
		backgroundColor: isDark ? "#100b0f" : "#fff8f2",
		backgroundDotsColor: null
	})
};
